// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"RichTextImage-module--imageWrapper--2jVfV","image":"RichTextImage-module--image--yFf0x","image_vertical":"RichTextImage-module--image_vertical--32jZK"};